import { getUserRoles } from "../../store/users/auth";

export enum Role {
  Approver = "Approver",
  FullRead = "FullRead",
  HumanResources = "HumanResources",
  Manager = "Manager",
  Regular = "Regular",
  SuperAdmin = "SuperAdmin",
  Admin = "Admin"
}

export const roles = () => {
  return Object.freeze({
    isApprover: getUserRoles().includes(Role.Approver),
    isFullRead: getUserRoles().includes(Role.FullRead),
    isHR: getUserRoles().includes(Role.HumanResources),
    isManager: getUserRoles().includes(Role.Manager),
    isRegular: getUserRoles().includes(Role.Regular),
    isSuperAdmin: getUserRoles().includes(Role.SuperAdmin),
    isAdmin: getUserRoles().includes(Role.Admin),
    isSuperAdminOrAdmin: getUserRoles().includes(Role.SuperAdmin) || getUserRoles().includes(Role.Admin),
    approver: Role.Approver,
    fullRead: Role.FullRead,
    humanResources: Role.HumanResources,
    manager: Role.Manager,
    regular: Role.Regular,
    superAdmin: Role.SuperAdmin,
    admin: Role.Admin,
    getAll: getUserRoles()
  });
};
